import { h } from 'preact'
export const IconFilter = () => {
    return (
         <svg
            width={'11px'}
            height={'10px'}
            viewBox="0 0 11 10"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
         >
          <g>
            <path d="M9.66602,6.90088H4.5c-.27637,0-.5,.22363-.5,.5s.22363,.5,.5,.5h5.16602c.27637,0,.5-.22363,.5-.5s-.22363-.5-.5-.5Z" fill="currentColor"/>
            <path d="M.5,2.72217H5.66602c.27637,0,.5-.22363,.5-.5s-.22363-.5-.5-.5H.5c-.27637,0-.5,.22363-.5,.5s.22363,.5,.5,.5Z" fill="currentColor"/>
            <path d="M7.66602,4.44531c.27637,0,.5-.22363,.5-.5v-1.22314h1.5c.27637,0,.5-.22363,.5-.5s-.22363-.5-.5-.5h-1.5V.5c0-.27637-.22363-.5-.5-.5s-.5,.22363-.5,.5V3.94531c0,.27637,.22363,.5,.5,.5Z" fill="currentColor"/>
            <path d="M2.5,5.17822c-.27637,0-.5,.22363-.5,.5v1.22266H.5c-.27637,0-.5,.22363-.5,.5s.22363,.5,.5,.5h1.5v1.22266c0,.27637,.22363,.5,.5,.5s.5-.22363,.5-.5v-3.44531c0-.27637-.22363-.5-.5-.5Z" fill="currentColor"/>
          </g>
        </svg>
    )
}

